import * as CONSTS from 'redux/constants/issuing/details';
import * as reduxUtil from 'redux/utils/reducers';

const initialState = {
  issuedPage: {},
  cardDetails: reduxUtil.initializeObject()
};

const reducer = (state = initialState, action: Record<string, any>) => {
  const { data, error } = action?.payload || {};
  switch (action.type) {
    case CONSTS.GET_ISSUED_PAGE_DATA_SUCCESS:
      return {
        ...state,
        issuedPage: action.payload
      };
    case CONSTS.GET_ISSUED_CARD_START:
      return reduxUtil.updateStartAction({ state, key: 'cardDetails' });
    case CONSTS.GET_ISSUED_CARD_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: 'cardDetails', data });
    case CONSTS.GET_ISSUED_CARD_FAIL:
      return reduxUtil.updateFailAction({ state, key: 'cardDetails', error });
    case CONSTS.SET_ISSUED_CARD_AS_EXPIRED:
      return {
        ...state,
        cardDetails: {
          ...state?.cardDetails,
          expired: true
        }
      };
    default:
      return state;
  }
};

export default reducer;
